import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import {
  IAgencyCastingCompanyRequestPayload,
  IAgencyCastingCompanyResponsePayload,
  ICastingCompanyResponsePayload,
  ICastingListRequestPayload,
  ICastingListResponsePayload,
} from 'shared/interfaces/ICasting';
import { AGENCY_CASTING_COMPANIES, CASTING_PROJECT_LIST, CASTING_COMPANIES } from 'shared/queries/casting.queries';

import { authToken } from 'shared/utils/authToken';

const { POST } = useAxios();
export const castingDao = () => {
  const { getAuthToken } = authToken();

  const searchCastingProjects = async (payload: ICastingListRequestPayload) => {
    const response = await POST<ICastingListResponsePayload>({
      url: ENDPOINTS.GRAPHQL,
      data: {
        query: CASTING_PROJECT_LIST,
        variables: {
          ...payload,
        },
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    if (response.data.errors) {
      throw new Error('Error' + response.data.errors);
    }

    return response.data;
  };

  const searchAgencyCastingCompanies = async (payload: IAgencyCastingCompanyRequestPayload) => {
    const response = await POST<IAgencyCastingCompanyResponsePayload>({
      url: ENDPOINTS.GRAPHQL,
      data: {
        query: AGENCY_CASTING_COMPANIES,
        variables: {
          ...payload,
        },
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    if (response.data.errors) {
      throw new Error('Error' + response.data.errors);
    }

    return response.data;
  };

  const searchCastingCompanies = async (payload: IAgencyCastingCompanyRequestPayload) => {
    const response = await POST<ICastingCompanyResponsePayload>({
      url: ENDPOINTS.GRAPHQL,
      data: {
        query: CASTING_COMPANIES,
        variables: {
          ...payload,
        },
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    if (response.data.errors) {
      throw new Error('Error' + response.data.errors);
    }

    return response.data;
  };

  return {
    searchCastingProjects,
    searchAgencyCastingCompanies,
    searchCastingCompanies,
  };
};
